import $ from 'jquery';

export default class {

    constructor() {
        this.init();
    }

    init() {
        $('.feature-item').click(function () {
            let id = $(this).attr('id');

            $('.active-feature').removeClass('active-feature');
            $(`.${id}`).addClass('active-feature');

        })
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/FeaturesToggle.js